// extracted by mini-css-extract-plugin
module.exports = {"content":"InitialMobile_content__7IqLe","already":"InitialMobile_already__IIQvy","spacer":"InitialMobile_spacer__2uY9n"};